import React from 'react';
import CardEmpreendimento from './CardEmpreendimento';
import '../../styles/empreendimentosStyle/ListaEmpreendimentos.css';
import type { Filtros } from './Filtros';

interface Empreendimento {
  id: number;
  nome: string;
  imagens: string[]; 
  tabela_preco?: string;
  valor_medio?: string;
  endereco?: {
      municipio?: string;
      bairro?: string;
    };
}

interface ListaEmpreendimentosProps {
  filtros: Filtros;
  empreendimentos: Empreendimento[];
}

export default function ListaEmpreendimentos({ filtros, empreendimentos }: ListaEmpreendimentosProps) {
  const pesquisaLower = filtros.pesquisa.trim().toLowerCase();

  const filtrados = empreendimentos.filter(item => {
    const nomeLower = item.nome?.toLowerCase() ?? "";
    const logradouroLower = item.endereco?.municipio?.toLowerCase() ?? "";
    const numeroStr = item.endereco?.bairro?.toLowerCase() ?? "";

    return (
      pesquisaLower === "" ||
      nomeLower.includes(pesquisaLower) ||
      logradouroLower.includes(pesquisaLower) ||
      numeroStr.includes(pesquisaLower)
    );
  });

  return (
    <div className="lista-empreendimentos">
      {filtrados.map(item => (
        <CardEmpreendimento key={item.id} empreendimento={item} />
      ))}
    </div>
  );
}
